// eslint-disable-next-line no-use-before-define
import React from 'react'
import { withRouter } from 'react-router';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { PageStatus } from '../../enums';
import { Show } from 'Layout';
import { AuthAPI } from '../../API';
import { connect } from "react-redux";
import PropTypes from 'prop-types';


class ForgetPasswordEmail extends React.Component {

  constructor(props) {
    super(props);
    (this.state = {
      error: null,
      status: PageStatus.None,
      email: '',
      showError: false,
      showSuccess: false,
    })

  }


  SendResetPasswordLink() {
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Submitting }))
      .then(() => AuthAPI.ResetPasswordLink(this.state.email, this.props.language))
      .then((res) => {
        if (res === "User with this email does not exists.") {
          toast.error('User with this email does not exist');
          this.setState({ showError: true, showSuccess: false })
        } else {
          toast.success('Password reset link sent to your email.');
          this.setState({ status: PageStatus.Submitted, email: '', showSuccess: true, showError: false })
        }
      })
      .catch((error) => {
        const message = (error && error.message)
          || 'Could not process your request. Please try again.';
        toast.error(message);
        this.setState({ status: PageStatus.Error, error: error && error.message });
      });

  }

  render() {
    return (
      <Modal
        centered
        size='md'
        backdrop='static'
        onHide={this.props.onClose}
        show={this.props.show}
      >
        <form onSubmit={(e) => {
          e.preventDefault();
          this.SendResetPasswordLink();
        }}>
          <Modal.Header closeButton>
            <h4>{this.props.language === 'hi' ? 'पासवर्ड भूल गए' : 'Forgot Password'}</h4>
          </Modal.Header>
          <Modal.Body>
            <div className=''>
              <div className='row'>
                <div className='col'>
                  <div className=''>
                    <label htmlFor='email' className='text-dark text-uppercase font-weight-bolder'>
                      {this.props.language === 'hi' ? 'ई-मेल एड्रेस' : 'Email Address'}
                    </label>
                    <input
                      name='email'
                      type='email'
                      value={this.state.email}
                      onChange={(e) =>
                        this.setState({ email: e.target.value })
                      }
                      className='form-control'
                      placeholder={this.props.language === 'hi' ? 'कृपया पंजीकृत ईमेल दर्ज करें' : 'Please enter registered email'}
                      maxLength={200}
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                      required
                    />
                    <Show when={this.state.showError}>
                      <p className="text-danger"> {this.props.language === 'hi' ? 'कृपया पंजीकृत ईमेल दर्ज करें' : 'Please enter registered email'} </p>
                    </Show>
                    <Show when={this.state.showSuccess}>
                      <p className="text-success">{this.props.language === 'hi' ? 'पासवर्ड रीसेट लिंक आपके ईमेल पर भेज दिया गया हैं' : 'Reset password link has been sent to your email'} </p>
                    </Show>
                  </div>
                </div>
              </div>
            </div>
            <div >

            </div>

          </Modal.Body>
          <div className="modal-footer">
            <button type="submit" disabled={!this.state.email} className="btn payment-btn-pay">
              {this.props.language === 'hi' ? 'लिंक भेजें' : "Send Link"} </button>
            <button onClick={this.props.onHide} className="btn payment-btn-cls ">{this.props.language === 'hi' ? 'बंद करे' : 'Close'}</button>
          </div>
        </form>
      </Modal>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    isAuth: state.adminUser.adminUser.isAuthenticated,
    token: state.adminUser.adminUser.token,
    language: state.adminUser.adminUser.language,
    isLoading: state.adminUser.adminUser.loading,
    error: state.adminUser.adminUser.error,
  };
};

const ForgetPasswordEmailWithState = withRouter(connect(
  mapStateToProps,
)(ForgetPasswordEmail));

ForgetPasswordEmail.propTypes = {
  language: PropTypes.string,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  onHide: PropTypes.func,
};

export {
  ForgetPasswordEmail,
  ForgetPasswordEmailWithState,
};



